import _extends from "@babel/runtime/helpers/esm/extends";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { customStyles, ClearIndicator, MultiValueLabel, NoOptionsMessage, DropdownIndicator, LoadingIndicator } from './CommonComponents/CommonComponents';
import { Components as ReactSelectComponents } from './select.style';
import { Box } from '..';
const AsyncReactSelect = _a => {
  var {
      customNoOptionsMessage,
      fit = 'medium',
      disabled,
      isCreatableOptions = false,
      loadOptions,
      variant = 'default',
      renderValue = 'label',
      onInputValueChange
    } = _a,
    rest = __rest(_a, ["customNoOptionsMessage", "fit", "disabled", "isCreatableOptions", "loadOptions", "variant", "renderValue", "onInputValueChange"]);
  return _jsx(Box, _extends({
    flex: "1",
    position: "relative"
  }, {
    children: !isCreatableOptions ? _jsx(ReactSelectComponents.AsyncReactSelect, _extends({
      classNamePrefix: "MultiSelect",
      components: {
        MultiValueLabel: props => _jsx(MultiValueLabel, _extends({}, props, {
          renderValue: renderValue
        })),
        DropdownIndicator: props => _jsx(DropdownIndicator, _extends({}, props)),
        LoadingIndicator: () => _jsx(LoadingIndicator, {
          fit: fit
        }),
        ClearIndicator: props => _jsx(ClearIndicator, _extends({}, props, {
          fit: fit,
          disabled: disabled
        })),
        NoOptionsMessage: props => _jsx(NoOptionsMessage, _extends({
          customNoOptionsMessage: customNoOptionsMessage
        }, props))
      },
      fit: fit,
      styles: customStyles,
      isDisabled: disabled,
      variant: variant,
      cacheOptions: true,
      loadOptions: loadOptions
    }, rest)) : _jsx(ReactSelectComponents.AsyncCreatableReactSelect, _extends({
      classNamePrefix: "MultiSelect",
      components: {
        MultiValueLabel: props => _jsx(MultiValueLabel, _extends({}, props, {
          renderValue: renderValue
        })),
        DropdownIndicator: props => _jsx(DropdownIndicator, _extends({}, props)),
        LoadingIndicator: () => _jsx(LoadingIndicator, {
          fit: fit,
          disabled: disabled
        }),
        ClearIndicator: props => _jsx(ClearIndicator, _extends({}, props, {
          fit: fit,
          disabled: disabled
        }))
      },
      fit: fit,
      styles: customStyles,
      isDisabled: disabled,
      variant: variant,
      cacheOptions: true,
      loadOptions: loadOptions
    }, rest))
  }));
};
export default AsyncReactSelect;